var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeLoader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 475 400",
    style: {
      enableBackground: "new 0 0 475 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{\n\t\tfill: white;\n\t\tstroke:#EE8254;\n\t\tstroke-width: 17;\n\t\tstroke-dasharray: 1350;\n\t\tanimation: dash 3s linear infinite;\n\t\tstroke-dashoffset: 1350;\n\t}\n\t@keyframes dash{\n\t\t0%{\n\t\t\tstroke-dashoffset: 2700;\n\t\t}\n\t\t50%{\n\t\t\tstroke-dashoffset: 1350;\n\t\t}\n\t\t100%{\n\t\t\tstroke-dashoffset: 0;\n\t\t}\n\t}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.5,388V130c0-2.8-2.2-5-5-5h-56l210-112.3l210,112.3h-56c-2.8,0-5,2.2-5,5v258H88.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLoader);
export default __webpack_public_path__ + "static/media/homeLoader.fbd0234a103822842e614572bbe1a3a8.svg";
export { ForwardRef as ReactComponent };